import { defineStore } from 'pinia'
import { ref } from 'vue'
import { $mqtt } from 'vue-paho-mqtt'
import { Logo } from '../interfaces/logo.mqtt.interface'
import { calculateFillingPercentage, calculateVolume } from '../services/helpers'
import { PanasonicHMI } from '../interfaces/panasonic.mqtt.interface'
import { Tags, TagsKey } from '../interfaces/tags.interface'

export const useMqttStore = defineStore('mqtt', () => {
  // Estado compartido
  const data = ref<Tags>({
    altura: 0,
    volumen: 0,
    volumen_100: 0,
    Frecuencia: 0,
    Potencia: 0,
    Irradiacion: 0,
    Corriente: 0,
  })

  const dashboard = ref<Tags>()

  // Topics y sus callbacks
  const topics = [
    {
      topic: 'embalse_pub',
      callback: handleLogoMessage,
      useMainTopic: false,
    },
    {
      topic: 'hmi_embalse_pub',
      callback: handleHmiMessage,
      useMainTopic: false,
    },
  ]

  // Manejo de mensajes de Logo
  function handleLogoMessage(message: string) {
    try {
      const logo: Logo = JSON.parse(message)
      const altura = +logo.state.reported.altura.value / 100
      data.value.altura = altura
      data.value.volumen_100 = +calculateFillingPercentage(altura)
      data.value.volumen = calculateVolume(altura)
    } catch (error) {
      console.error('Error procesando mensaje de Logo:', error)
    }
  }

  // Manejo de mensajes de HMI
  function handleHmiMessage(message: string) {
    try {
      const fixedJson = message
        .replace(/"tag":\s*([\w]+)/, '"tag": "$1"')
        .replace(/"ts":\s*([\d\-:TZ.]+)/, '"ts": "$1"')
      const hmi: PanasonicHMI = JSON.parse(fixedJson)
      if (hmi.tag && data.value[hmi.tag as TagsKey] !== undefined) {
        data.value[hmi.tag as TagsKey] = hmi.v.v
      } else {
        console.warn(`Tag no válido: ${hmi.tag}`)
      }
    } catch (error) {
      console.error('Error procesando mensaje de HMI:', error)
    }
  }

  // Conectar MQTT
  async function connectMQTT() {
    if ($mqtt.status() === 'connected') return // Evitar reconexión innecesaria
    try {
      await $mqtt.connect()
      mqttSubscribe()
    } catch (error) {
      console.error('Error conectando a MQTT:', error)
    }
  }

  // Desconectar MQTT
  function disconnectMQTT() {
    if ($mqtt.status() === 'disconnected') return // Evitar desconexión innecesaria
    try {
      $mqtt.disconnect()
    } catch (error) {
      console.error('Error desconectando de MQTT:', error)
    }
  }

  // Suscribir a los tópicos
  function mqttSubscribe() {
    topics.forEach((topic) => {
      try {
        $mqtt.subscribe(topic.topic, topic.callback, topic.useMainTopic)
        console.log(`Suscrito a: ${topic.topic}`)
      } catch (error) {
        console.error(`Error suscribiéndose a ${topic.topic}:`, error)
      }
    })
  }

  return {
    data,
    dashboard,
    connectMQTT,
    disconnectMQTT,
    mqttSubscribe,
  }
})
